// extracted by mini-css-extract-plugin
module.exports = {"gwpZone":"GwpProducts_gwpZone__I15Hm","gwpContent":"GwpProducts_gwpContent__2hYil","gwpHeader":"GwpProducts_gwpHeader__1Jdh5","gwpLegal":"GwpProducts_gwpLegal__23sUy"};